define('areas/organizationmanager/commands/createinfrastructurecommand',["require", "exports", "services/trace", "services/httpclient"], function (require, exports, Trace, Http) {
    "use strict";
    var CreateInfrastructureCommand = (function () {
        function CreateInfrastructureCommand(taskManager) {
            this._taskManager = taskManager;
        }
        CreateInfrastructureCommand.prototype.execute = function (organization) {
            try {
                var httpClient = new Http.Channel();
                this._taskManager.start("Nachricht für die Organisationsstrukture wird verschickt...", function () {
                    httpClient.putData("/api/organization/createorganizationstructure?organizationId=" + organization.id, Http.ServiceTarget.portalApi, null).
                        then(function (data) {
                        Trace.traceInformation("Die Anforderung um die Datenbank zu erstellen wurde erfolgreich verschickt.");
                    }).fail(function (error) {
                        Trace.traceError(error.responseJSON.Message, null, "organizationmanager:index", true);
                    });
                });
            }
            catch (exception) {
                Trace.traceError(exception, null, "organizationmanager:index", true);
            }
        };
        return CreateInfrastructureCommand;
    }());
    return CreateInfrastructureCommand;
});

